import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "sensitive-container"
};
const _hoisted_2 = {
  class: "assets-name"
};
const _hoisted_3 = {
  class: "sensitive-words"
};
const _hoisted_4 = {
  key: 1,
  class: "sensitive-numpty"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_button, {
    link: "",
    size: "small",
    onClick: $setup.showSensitiveWords
  }, {
    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("查看敏感词", -1)]))]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_dialog, {
    title: "敏感词",
    width: "30%",
    "show-close": true,
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.visible = $event),
    onClose: $setup.close,
    "append-to-body": ""
  }, {
    default: _withCtx(() => [_ctx.sensWordsList && _ctx.sensWordsList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sensWordsList, sw => {
      return _openBlock(), _createElementBlock("div", {
        class: "sensitive-item",
        key: sw.assetsId
      }, [_createElementVNode("div", _hoisted_2, _toDisplayString(sw.assetsName) + ":", 1), _createElementVNode("div", _hoisted_3, _toDisplayString(sw.sensitiveWords), 1)]);
    }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_4, "暂无敏感词"))]),
    _: 1
  }, 8, ["modelValue", "onClose"])], 64);
}